interface BrandLogoProps {
  size?: number;
}

export default function BrandLogo({ size = 32 }: BrandLogoProps) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-[10px] bg-gradient-to-br from-[#E08812] to-amber-700 text-white shadow-ds-1"
      style={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        style={{ width: Math.round(size * 0.56), height: Math.round(size * 0.56) }}
      >
        <path d="M12 3.4 18.9 7.3v7.4L12 20.6 5.1 14.7V7.3L12 3.4Z" fill="rgba(255,255,255,.18)" />
        <path d="m9 10.7 3-1.7 3 1.7v3.1l-3 1.6-3-1.6Z" fill="rgba(255,255,255,.94)" stroke="none" />
      </svg>
    </span>
  );
}
